import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { createResult } from 'actions';
import { selectUserResult, resultHasError } from 'selectors';

import Layout from 'Components/Layout/Layout';

import { LoadingPage } from 'frontend-component-library';
import { Redirect } from 'react-router-dom';

class ResultsLoadingPage extends PureComponent {
  componentDidMount() {
    const { currentUserResult, createResult } = this.props;
    if (!currentUserResult.uuid) {
      createResult();
    }
  }

  render() {
    const { currentUserResult, resultHasError } = this.props;
    if (currentUserResult.status === 'ready') {
      // Redirect to the results page
      return <Redirect to={`/results/${currentUserResult.uuid}`} from="/" />;
    }

    return (
      <Layout>
        <div className="ResultLoadingPage">
          {resultHasError ? (
            // Redirect to results error page
            <Redirect to="/results/error" />
          ) : (
            <LoadingPage text="Loading your results..." />
          )}
        </div>
      </Layout>
    );
  }
}

ResultsLoadingPage.propTypes = {
  currentUserResult: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    currentUserResult: selectUserResult(state),
    resultHasError: resultHasError(state),
    endpointErrors: state.endpointErrors,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createResult: createResult,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultsLoadingPage);



// WEBPACK FOOTER //
// ./src/Components/Pages/ResultsLoadingPage.js